var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('difference-select',{attrs:{"differenceList":_vm.differenceList,"title":"差異対処"},on:{"onDialogClose":_vm.onCancelClick,"onDialogSetting":_vm.onDifferenceSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }